export default {
    languageType: 'en',
    lang: 'en',
    welcome: 'WELCOME',
    select_your_language: 'SELECT YOUR LANGUAGE',
    select_theme: 'SELECT YOUR THEME',
    phone_number_placeholder: 'Mobile Number',
    whats_your_phone_number: "What's your mobile number?",
    lets_create_your_account: 'Let’s create your account.',
    enter_mobile_number: 'Enter Mobile Number',
    enter_your_phone: 'Enter your phone',
    enter_password: 'Enter your password',
    enter_email: 'Enter your email address',
    login: 'Login',
    forgot_password: 'Forgot password?',
    lets_create_account: 'Let’s create your account',
    signing_oscar_is_fast: 'Signing up for Oscar is fast and free. No commitments or long-term contracts',
    first_name: 'First name',
    last_name: 'Last name',
    enter_your_phone_number: 'Enter your phone number',
    create_password: 'Create a password',
    confirm_password: 'Confirm new password',
    continue: 'Continue',
    account_created: 'Congratulations, your account is ready to roll! 🎉',
    few_more_questions: "Let's put the finishing touches together to ensure you have all the right tools to start earning.",
    tell_us_about_business: 'Tell us a little about your business',
    help_you_get_start: 'We’ll help you get started based on your responses',
    thank_you: 'Thank you',
    starting_pos: 'We are loading your journey to success',
    start_selling: 'Add your precious items and start winning',
    items: 'Items',
    settings: 'Settings',
    pos: 'Pos',
    session: 'POS',
    language: 'Language',
    profile: 'Profile',
    backup_now: 'Back up now',
    logout: 'Logout',
    add_customer: 'Add customer',
    create_new_customer_and_add_to_sale: 'Create new customer and add to sale',
    create_new_waiter_and_add_to_sale: 'Create new waiter and add to sale',
    before_you_open: 'Before you open your store, first you need some products',
    import_customers: 'Import customers',
    create_customer: 'Create customer',
    set_up_team: 'Set up team',
    second_let_create_your_team: "Second, let's create your team",
    set_up_your_team_members: 'Set up your team members and configure permissions',
    create_member: 'Create member',
    next: 'Next',
    pos_is_loading: 'Your POS is loading',
    stay_few_seconds: 'Stay with us for few seconds',
    create_an_item: 'Create an item',
    item_details: 'Item details',
    pricing: 'Pricing',
    inventory: 'Inventory',
    name: 'Name',
    category: 'Category',
    description: 'Description',
    locations: 'Locations',
    all_location: 'All Locations',
    price: 'Price',
    drag_image_here: 'Drag image here,',
    upload: 'upload',
    browse_image_library: 'browse image library.',
    compare: 'Compare at price',
    charge_tax: 'Charge tax on this product',
    cost_per_item: 'Cost per item',
    tax_value: 'Tax',
    profit: 'Profit',
    margin: 'Margin',
    track_quantity: 'Track quantity',
    add_qty: 'Add Qty',
    stock_alert: 'Low stock alert',
    sku: 'SKU',
    barcode: 'Barcode',
    variants: 'Variants',
    add_variant_options: 'Add options like size or color',
    set_up_inventory: 'Set up Inventory',
    import_items: 'Import items',
    create_item: 'Create Item',
    error: 'Error',
    setup_guide: 'Setup guide',
    nav_pos: 'POS',
    suppliers: 'Suppliers',
    orders_history: 'Orders history',
    customers: 'Customers',
    discounts: 'Discounts',
    taxes: 'Taxes',
    invoices: 'Invoices',
    purchase_order: 'Purchase order',
    reports: 'Reports',
    teams: 'Teams',
    nav_logout: 'Logout',
    //
    we_will_send_you_verification_code: 'We will send you a verification code',
    oscar_is_fast_and_free_forever: 'Oscar is fast and free, forever.',
    we_have_sent_a_verification_code_to: 'We have sent a verification code to',
    no_internet_please_login_again: 'No internet, please login again',
    timeout_message: "There's a problem in restoring your data, please log in again",
    enter_your_verification_code: 'Enter Your Verification Code',
    verification_code: 'VERIFICATION CODE',
    view_report: 'View report',
    business_updated_success: 'Business Updated successfully',
    coming_soon: 'Coming Soon',
    search_or_scan_items: 'Search or scan items (Shift+S)',
    first_up_what_are_you_selling: 'First up: what are you selling?',
    before_you_open_your_store: 'Before you open your store, first you need some products.',
    dont_have_an_account: "Don't have an account?",
    create_an_account: 'Create new account',
    back: 'Back',
    skip: 'Skip',
    phone_number_format: 'Phone number should be in format e.g. 03xxxxxxxxx',
    password_does_not_match: 'Password does not match',
    enter_username: 'Enter your username',
    what_kind_of_business_are_you: 'What kind of business are you?',
    what_is_your_business_type: 'What is your business type?',
    province: 'Province',
    city: 'City',
    what_is_your_business_name: 'Enter your business name',
    address: 'Address',
    username_already_exists: 'Username already exists',
    phone_already_exists: 'Phone number already exists',
    api_is_down: 'Api is down',
    use_this_personalized_guide_to_get_your_store: 'Use this personalized guide to get your store up and running.',
    owner: 'Owner',
    set_up_printer: 'Set up printer receipt',
    last_lets_set_up_printer: "Last, let's set up your printer",
    configure_your_printer_and_receipts: 'Configure your printer & receipts',
    save: 'Save',
    add_photo: 'Add Photo',
    customer_details: 'Customer details',
    selling_price_is_required: 'Selling price is required',
    cost_price_is_required: 'Cost price is required',
    quantity_is_required: 'Quantity is required',
    enter_name: 'Enter name',
    phone_number: 'Phone number',
    enter_phone_number: 'Enter phone number',
    email_address_optional: 'Enter email address (optional)',
    enter_email_address: 'Enter Email address',
    select_dat_birth: 'Select date of birth',
    province_optional: 'Province (optional)',
    select_province: 'Select Province',
    city_optional: 'City (optional)',
    select_city: 'Select City',
    address_optional: 'Address (optional)',
    enter_address: 'Enter address',
    create_team_member: 'Create a team member',
    team_member_details: 'Team member details',
    hold: 'Hold',
    new: 'New',
    delete: 'Delete',
    create_an_option: 'Create an option',
    create_variants: 'Create variants',
    create_variant_first_create_option: 'To create a variant, first create an option set.',
    see_video: 'See video',
    option_set: 'Option set',
    size_color_etc: 'Size, color, etc',
    option: 'Option',
    options: 'options',
    option_set_type: 'Option set type',
    small_medium_large: 'small, medium, large, etc',
    option_type: 'Option type',
    values: 'Values',
    text: 'Text',
    text_and_color: 'Text & color',
    value_already_selected: 'Value already selected',
    please_enter_a_value: 'Please enter a value',
    do_you_want_to_create_variants: 'Do you want to create variants',
    yes: 'Yes',
    or: 'or',
    no: 'No',
    add_option_set: 'Add option set',
    add_option_like_size_color: 'Add options like size or color',
    create_option: 'Create option',
    select_option: 'Select option',
    variations_below_will_be_created: 'The variations below will be created from your options.',
    all_variations: 'All variations',
    variation_list: 'Variation list',
    discard: 'Discard',
    close: 'Close',
    variations: 'Variation',
    quantity: 'Quantity',
    cost_price: 'Cost price',
    sell_price: 'Sell price',
    unit: 'Unit',
    secondary_unit: 'Secondary unit',
    conversion_rate: 'Conversion rate',
    low_stock: 'Low stock',
    enter_barcode: 'Enter barcode',
    select_tax: 'Select Tax',
    order: 'Order',
    item_image: 'Item Image',
    edit: 'Edit',
    upload_image: 'Upload image',
    set_your_opening_balance: 'Set your opening balance',
    date: 'Date',
    opening_balance: 'Opening balance',
    submit: 'Submit',
    create_pin_code: 'Create 4 digit pin code',
    pin_code: 'Pin code',
    enter_pin_code: 'Enter pin code',
    ok: 'Ok',
    cancel: 'Cancel',
    search_item_by_name_and_barcode: 'Search items by name and barcode (Shift + S)',
    all_inventory: 'All inventory',
    actions: 'Actions',
    import_library: 'Import library',
    export_library: 'Export Library',
    search_item_by_name: 'Search item by name, barcode or SKU',
    low_stock_alert: 'Low stock alert',
    sold_out: 'Sold out',
    stock_available: 'Stock available',
    duplicate: 'Duplicate',
    create_quick_item: 'Create quick item',
    categories: 'Categories',
    open_item: 'Open item (Shift + O)',
    open_item_name: 'Open item',
    add_new_item: 'Add new item (Shift + N)',
    payment_shift: 'Payment (Shift + Enter)',
    item_list: 'Item List',
    clear_all_items: 'Clear all items',
    sub_total: 'Sub total',
    total_tax: 'Total tax',
    discount: 'Discount',
    bill_amount: 'Bill amount',
    invalid_pin: 'Invalid pin',
    home: 'Home',
    all_customers: 'All Customers',
    create_quick_customer: 'Create quick customer',
    phone_num: 'Phone #',
    last_visited: 'Last visited',
    visits: 'Visits',
    created: 'Created',
    average_spend: 'Average spend',
    credit_amount: 'Credit amount',
    total_spent: 'Total spent',
    search_customer_by_name: 'Search customers by name or number',
    date_of_birth_optional: 'Date of birth (optional)',
    enter_cash_amount: 'Enter cash amount',
    change: 'Change',
    payments: 'Payments',
    redeem_points: 'Redeem points',
    order_discount: 'Order discount',
    cash: 'Cash',
    card: 'Card',
    wallet: 'Wallet',
    credit: 'Credit',
    customer_information: 'Customer Information',
    order_id: 'Order ID',
    amount: 'Amount',
    record_payment: 'Record Payment (Enter)',
    swipe_your_card: 'Swipe your card on machine',
    amount_paid_via: 'Amount paid via',
    charged: 'Charged',
    transaction_successful: 'Transaction successful',
    print_receipt: 'Print receipt',
    create_new_discount: 'Create new discount',
    create_discount: 'Create discount',
    discount_details: 'Discount Details',
    create: 'Create',
    discount_name: 'Discount Name',
    enter_discount_name: 'Enter discount name',
    taxation_behaviour: 'Taxation behavior',
    select_taxation_behaviour: 'Select taxation behaviour',
    discount_amount_limit: 'Discount amount limit',
    enter_discount_amount_limit: 'Enter discount amount limit',
    select_discount_type: 'Select discount type',
    max_discount_cap: 'Max discount cap',
    enter_max_discount_cap: 'Enter max discount cap',
    location: 'Location',
    create_location: 'Create location',
    select_location: 'Select location',
    search_discounts_by_name: 'Search discounts by name or type',
    discount_amount: 'Discount amount',
    discount_type: 'Discount type',
    discount_given: 'Discount given',
    tax_exclusive: 'Tax exclusive',
    tax_inclusive: 'Tax inclusive ',
    type_percentage: 'Percentage (%)',
    type_amount: 'Amount (Rs.)',
    discount_credit_cards_entire_orders: 'Discounts for credit cards & entire orders',
    example_hbl_discount_student_discount: '(e.g. HBL discount, 20% student discount)',
    pos_discounts: 'POS discounts',
    pos_discount: 'POS discount',
    new_order: 'New order (Shift + N)',
    for_receipt: 'For receipt : enter phone',
    send: 'Send',
    search_sales_tax_by_name: 'Search sales tax by name',
    create_new_sales_tax: 'Create new sales tax',
    create_sales_tax: 'Create sales tax',
    sales_tax_details: 'Sales tax details',
    tax_name: 'Tax name',
    tax_rate: 'Tax rate %',
    tax_application: 'Tax application',
    tax_calculation: 'Tax Calculation',
    applied_on: 'Applied on # of items',
    enter_sales_tax_name: 'Enter sales tax name',
    enter_tax_rate: 'Enter tax rate in %',
    select_tax_calculation: 'Select tax calculation',
    select_tax_application: 'Select tax application',
    calculate_tax_on_pre_discount: 'Calculate tax based on the pre-discount price',
    calculate_tax_on_post_discount: 'Calculate tax based on the post-discount price',
    on_all_items: 'On all items',
    select_items: 'Select items',
    order_level_discount: 'Order level discount',
    done: 'Done',
    select_order_level_discount: 'Select order level discount type',
    rs: 'Rs.',
    percent: '%',
    final_bill_amount: 'Final bill amount',
    cash_amount: 'Cash amount',
    email: 'Email',
    date_of_birth: 'Date of birth',
    sales_tax_created_in_oscar_dashboard: 'Sales tax created in oscar dashboard will sync to all devices signed in to this account.',
    the_tax_amount_will_be_automatically: 'The tax amount will be automatically calculated at purchase.',
    create_purchase_tax: 'Create purchase tax',
    purchase_tax_details: 'Purchase tax details',
    all_taxes: 'All taxes',
    sales_tax: 'Sales tax',
    purchase_tax: 'Purchase tax',
    create_tax: 'Create tax',
    selected_items: 'Selected items',
    multiple_items: 'Multiple items',
    create_category: 'Create category',
    category_details: 'Category details',
    category_name: 'Category name',
    enter_category_name: 'Enter category name',
    total_inclusive_tax: 'Total inclusive tax',
    total_exclusive_tax: 'Total exclusive tax',
    search_order_by_id: 'Search order by ID',
    all_orders: 'All orders',
    confirmed_orders: 'Confirmed orders',
    cancel_orders: 'Cancel orders',
    details: 'Details',
    delete_order: 'Delete order',
    order_number: 'Order #',
    cashier: 'Cashier',
    customer: 'Customer',
    payment_status: 'Payment status',
    total: 'Total',
    order_history: 'Order history',
    you_havent_placed_any_order: "you haven't placed any order yet, Start selling",
    payment_method: 'Payment method',
    visits_lower: 'visits',
    visit: 'visit',
    held_orders: 'Held orders',
    search_order_by_name_number: 'Search order by name or number',
    filter: 'Filter',
    all: 'All',
    most_recent: 'Most recent',
    tax_type: 'Tax type',
    hold_order: 'Hold order',
    are_you_sure_you_want_to_hold_order: 'Are you sure you want to hold this order',
    import_purchaseorder: 'Import purchase order',
    export_purchaseorder: 'Export purchase order',
    auto: 'Auto',
    draft: 'Draft',
    partially_received: 'Partially received',
    pending: 'Pending',
    received: 'Received',
    create_po: 'Create PO',
    import_po: 'Import PO',
    sales: 'Sales',
    purchase: 'Purchase',
    search_vendor_order_no: 'Search Vendor or Order #',
    edit_customer: 'Edit customer',
    rate: 'Rate',
    type: 'Type',
    given: 'Given',
    edit_sales_tax: 'Edit sales tax',
    edit_purchase_tax: 'Edit purchase tax',
    search_tax_by_name: 'Search tax by name',
    edit_product: 'Edit product',
    discount_rate: 'Discount rate',
    enter_discount_rate: 'Enter discount rate',
    edit_discount: 'Edit discount',
    print: 'Print',
    loyalty_point_available: 'Loyalty point available',
    payment_received_by_cash_of: 'Payment received by cash of',
    payment_received_by_card_of: 'Payment received by card of',
    refund: 'Refund',
    add_a_note_to_the_order: 'Add a note to the order',
    history: 'History',
    refund_updated_send_sms_to_customer: 'Refund updated, send SMS to customer',
    resend_sms: 'Resend SMS',
    archived: 'Archived',
    archive: 'Archive',
    unarchive: 'Unarchive',
    are_you_sure_you_want_to_delete_order: 'Are you sure you want to delete this order',
    archive_product: 'Archive product',
    are_you_sure_you_want_to_archive: 'Are you sure you want to archive ',
    are_you_sure_you_want_to_unarchive: 'Are you sure you want to unarchive ',
    archive_discount: 'Archive discount',
    all_discounts: 'All discounts',
    archive_tax: 'Archive tax',
    set_your_closing_balance: 'Set your closing balance',
    closing_balance: 'Closing balance',
    are_you_sure_you_want_to_logout: 'Are you sure you want to logout?',
    add_additional_option_set: 'Add additional option set',
    archive_customer: 'Archive customer',
    create_purchase_order: 'Create purchase order',
    lets_create_your_account_po: 'Let’s create your account PO',
    enter_order_information: 'Enter order information',
    save_draft: 'Save draft',
    denerate_purcahse_order: 'Genterate purchase order.',
    team_member_permission: 'Team member permission',
    team_member_name: 'Team member name',
    cnic: 'CNIC #',
    upload_cnic_front: 'Upload CNIC front',
    upload_cnic_back: 'Upload CNIC back',
    cnic_information: 'CNIC  information',
    phone: 'Phone',
    password: 'Password',
    required_password: 'Password is required',
    pos_pin: 'POS pin',
    point_of_Sale: 'Point of Sale',
    allow_team_member_to_control_genteral_POS_functions: 'Allow team member to control genteral POS functions.',
    head_cashier: 'Head Cashier',
    manager: 'Manager',
    waiter: 'Waiter',
    create_waiter: 'Create waiter',
    waiter_details: 'Waiter details',
    create_and_manage_your_team: 'Create and manage your team',
    create_waiter: 'Create waiter',
    allow_team_member_to_control_inventory_management: 'Allow team member to control inventory management.',
    purchasing: 'Purchasing',
    allow_team_member_to_control_purchasing_system: 'Allow team member to control purchasing system.',
    sales_invoicing: 'Sales Invoicing',
    allow_team_member_to_manage_sales_invoicing: 'Allow team member to manage sales invoicing.',
    products: 'Products',
    allow_team_member_to_create_and_manage_products: 'Allow team member to create and manage products.',
    manufacturing: 'Manufacturing',
    allow_team_member_to_manufacture_products: 'Allow team member to manufacture products.',
    requester: 'Requester',
    approver: 'Approver',
    role: 'Role',
    select_role: 'Select Role',
    role_details: 'Role Details',
    create_role: 'Create Role',
    all_role: 'All role',
    role_name: 'Role Name',
    search_team_member_by_phone: 'Search team member by phone',
    transfer_receiver: 'Transfer receiver',
    po_Receiver_Distribution_operator: 'PO / Receiver / Distribution operator',
    auditor: 'Auditor',
    user: 'User',
    products_manager: 'Products manager',
    chef: 'Chef',
    allowed_pos: 'Allowed POS',
    bag_a_Bagel_POS_Admin: 'Bag a Bagel - POS (Admin)',
    generate_purcahse_order: 'Generate purchase order.',
    company: 'Company',
    ship_to: 'Ship to',
    purchase_order_date: 'Purchase order date',
    expected_on: 'Expected on',
    notes: 'Notes',
    reference: 'Reference',
    shipping_method: 'Shipping method',
    add_item_information: 'Add item information',
    type_item_name_SKU_or_Barcode: 'Type item name, SKU or Barcode',
    notes_Memo: 'Notes / Memo',
    qty: 'Qty',
    unit_cost: 'Unit cost',
    subtotal: 'Subtotal',
    add_global_discount_amount: 'Add global discount amount',
    total_amount: 'Total amount',
    cash_on_delivery: 'Cash on delivery',
    via_Bank_on_delivery: 'Via Bank on delivery',
    create_company: 'Create company',
    company_details: 'Company details',
    enter_company_name: 'Enter company name',
    email_address: 'Email address',
    country_region: 'Country/Region',
    state_province: 'State/Province',
    zip_postal: 'Zip/Postal code',
    enter_zip_postal: 'Enter Zip/Postal code',
    send_purchase_order: 'Send purchase order',
    would_you_like_to_email_or_Save_a_copy_of_your_order: 'Would you like to email or Save a copy of your order?',
    to: 'To',
    pdf: 'PDF',
    csv: 'CSV',
    save_your_purchase_order_as: 'Save your purchase order as',
    send_me_a_copy: 'Send me a copy',
    create_supplier: 'Create supplier',
    import_suppliers: 'Import suppliers',
    cnic_front_uploaded: 'CNIC front uploaded',
    cnic_back_uploaded: 'CNIC back uploaded',
    unarchived: ' Unarchived',
    are_you_sure_you_want_to_archive_the_selected_Customer: 'Are you sure you want to archive the selected Customer?',
    are_you_sure_you_want_to_unarchive_the_selected_Customer: 'Are you sure you want to unarchive the selected Customer?',
    unarchive_customer: 'Unarchive customer',
    are_you_sure_you_want_to_archive_the_taxes_Customer: 'Are you sure you want to archive the selected taxes?',
    are_you_sure_you_want_to_unarchive_the_taxes_Customer: 'Are you sure you want to unarchive the selected taxes?',
    unarchive_tax: 'Unarchive tax',
    are_you_sure_you_want_to_archive_the_selected_discount: 'Are you sure you want to archive the selected discount?',
    are_you_sure_you_want_to_unarchive_the_selected_discount: 'Are you sure you want to unarchive the selected discount?',
    unarchive_discount: 'Unarchive discount',
    are_you_sure_you_want_to_archive_the_selected_product: 'Are you sure you want to archive the selected product?',
    are_you_sure_you_want_to_unarchive_the_selected_product: 'Are you sure you want to unarchive the selected product?',
    unarchive_product: 'Unarchive product',
    loyalty_points_earned: 'Loyalty points earned',
    loyalty: 'loyalty',
    buyer_Summary: 'Buyer Summary',
    first_visit: 'First visit',
    last_visit: 'Last visit',
    frequency: 'Frequency',
    order_details: 'Order details',
    upload_and_create_your_inventory: 'Upload and create your inventory',
    upload_CSV_file: 'Upload CSV file',
    select_a_file_or_drag_and_drop_here: 'Select a file or drag and drop here',
    or_select_files_from_device: 'or select files from device',
    max_50MB: 'max. 50MB',
    select_file: 'Select file',
    download_CSV_template: 'Download CSV template',
    po_item_error: 'Quantity, unit and cost are required fields',
    po_num: 'PO #',
    status: 'Status',
    purchase_date: 'Purchase date',
    vendor: 'Vendor',
    approve_po: 'Approve',
    reject_po: 'Reject',
    mark_as_delivered: 'Mark as delivered',
    mark_as_complete: 'Mark as complete',

    delivered: 'Delivered',
    rejected: 'Rejected',
    username: 'Username',
    amount_outstanding: 'Amount Outstanding',
    add_invoices: 'Add Invoices',
    add_report: 'Add report',
    create_invoices: 'Create Invoices',
    import_invoices: 'Import Invoices',
    create_report: 'Create report',
    import_report: 'Import report',
    add_supplier: 'Add Supplier',
    create_new_supplier_and_add_to_sale: 'Create new supplier and add to sale',
    before_you_open_your_store_first_you_need_some_supplier: 'Before you open your store, first you need some supplier',
    create_new_invoice_and_add_to_sale: 'Create new invoice and add to sale',
    before_you_open_your_store_first_you_need_some_invoice: 'Before you open your store, first you need some invoice',
    create_new_purchase_order_and_add_to_item: 'Create new purchase order and add to item',
    before_you_open_your_store_first_you_need_some_purchase_order: 'Before you open your store, first you need some purchase order',
    create_report_and_add_to_sale: 'Create new report and add to sale',
    before_you_open_your_store_first_you_need_some_report: 'Before you open your store, first you need some report',
    please_adjust_the_settings_according_to_your_preferences: 'Please adjust the settings according to your preferences',
    before_opening_your_store_you_need_to_adjust_the_settings_first: 'Before opening your store, you need to adjust the settings first',
    new_order2: 'New order',
    check_out: 'Check Out',
    add_customer_to_sale: 'Add customer to sale',
    create_new_customer: 'Create new customer',
    search_customer_name_phone_or_email: 'Search customer name, phone or email',
    select_payment_method: 'Select payment method',
    udhaar: 'udhaar',
    enter_amount: 'Enter amount',
    item_level_discount: 'Item level discount',
    rupees: 'Rupees',
    percentage: 'Percentage',
    item_level_discount_added: 'Item level discount added',
    update_Customer: 'Update Customer',
    new_order_toolpit_desc: 'Before starting new order do you want to save this order to saved orders list?',
    order_saved: 'Order saved',
    order_cleared: 'Order clear successfully',
    saved_order: 'Saved order',
    resume_order: 'Resume order',
    clear_all_item: 'Clear all items?',
    do_you_want_to_clear_all_the_items_in_the_list: 'Do you want to clear all the items in the list?',
    order_resumed_successfully: 'Order resumed successfully',
    remove_Customer: 'Remove Customer',
    search_discounts_by_name: 'Search discounts by name...',
    new_to_oscar: 'New to Oscar?',
    get_started: 'Get started',
    already_have_an_account: 'Already have an account?',
    pos_cockpit: 'POS Cockpit',
    dine_in: 'Dine In',
    take_away: 'Take away',
    delivery: 'Delivery',
    time: 'Time',
    table: 'Table',
    rider: 'Rider',
    nothing_found_create_order: 'Nothing found, please create order',
    table_details: 'Table Details',
    appearance: 'Appearance',
    table_name: 'Table name',
    no_of_seats: 'No of seats',
    table_shape: 'Table shape',
    table_width: 'Table width (px)',
    table_height: 'Table height (px)',
    dashboard: 'Dashboard',
    orders_overview: 'Orders overview',
    total_sales: 'Total sales',
    total_orders: 'Total orders',
    hold_orders: 'Hold orders',
    cancelled_orders: 'Cancelled orders',
    payment_types: 'Payment types ',
    gross_sales: 'Gross Sales',
    transactions: 'Transactions',
    avg_net_sale: 'Average net sale',
    returns: 'Returns',
    net_sales: 'Net sales',
    total_customers: 'Total customers',
    new_customers: 'New customers',
    returning_customers: 'Returning customers',
    avg_spent_per_customer: 'Avg. spent per customer',
    conversion_rate: 'Conversion rate',
    top_10_items: 'Top 10 items',
    top_10_categories: 'Top 10 categories',
    devices: 'Devices',
    search_kds_by_name: 'Search KDS by name',
    device_name: 'Device Name',
    new_kitchen_display: 'New Kitchen Display',
    kitchen_display: 'Kitchen Display',
    sign_in_with_device_code: 'Sign in with device code',
    add_kds_device: 'Add a KDS device',
    generating_device_code: 'Generating device code',
    stay_with_us: 'Stay with us for few seconds',
    kitchen_display_devices: 'Kitchen Display Devices',
    send_device_code: 'Send Device Code',
    send_code_to_email: 'Send this device code to an email to sign in Oscar kitchen display',
    create_four_digit_pin: 'Create a 4 digit pin code',
    confirm_pin_code: 'Confirm pin code',
    third_party_integration: 'Third party integration',
    integrate_kds_with_odoo: 'Integrate you KDS with Odoo Oscar POS',
    connect_odoo: 'Connect Odoo',
    connected: 'Connected',
    paired: 'Paired',
    unpaired: 'Unpaired',
    copy: 'Copy',
    device_code_are_created_for_each_device: 'Device codes are created in dashboard for each new device, allowing you to sign in without ever sharing your email and password.',
    hold_tight: 'Hold tight',
    all_incoming_orders_will_display_here: 'All incoming orders will display here',
    mark_all_as_ready: 'Mark all as ready',
    mark_as_complete: 'Mark as complete',
    completed_orders_will_show_up_here: 'The completed orders will show up here',
    order_completed: 'Order Completed',
    order_status: 'Order Status',
    order_type: 'Order Type',
    time_taken: 'Time Taken',
    recall_order: 'Recall order',
    notifications: 'Notifications',
    new_notifications_will_show_up_here: 'New notifications will show up here',
    order_items: 'Order items',
    device_created: 'Device created',
    connect_your_kds_device_with_code: 'Connect your KDS device with a code.',
    url: 'Url',
    dine_in: 'Dine In',
    delivery: 'Delivery',
    take_away: 'Takeaway',
    green_timer: 'Green timer',
    yellow_timer: 'Yellow timer',
    red_timer: 'Red timer',
    play_sound_when_new_order_arrives: 'Play sound when new order arrives',
    play_sound_when_item_or_order_cancelled: 'Play sound when item or order cancelled',
    play_sound: 'Play sound',
    activate_ticket_timer_after: 'Activate ticket timer after',
    configuration: 'Configuration',
    display_information: 'Display information',
    display_name: 'Display name',
    sign_in_date: 'Sign in date',
    point_of_sale_system: 'Point of Sale System',
    confirm_pin: 'Confirm PIN',
    confirm: 'Confirm',
    karachi: 'karachi',
    lahore: 'Lahore',
    hyderabad: 'Hyderabad',
    search_by_name_or_order_number: 'Search by name or order number',
    paid: 'Paid',
    create_floor_plan: 'Create floor plan',
    floor_plan_details: 'Floor plan details',
    floor_plan_name: 'Floor plan name',
    is_it_dinein_floor_or_delivery_floor: 'Is it dine in floor or delivery floor?',
    add_tables: 'Add tables',
    setup_modifiers: 'Setup modifiers',
    setup_modifiers_and_customize: 'Setup modifiers and customize your items',
    create_modifier: 'Create modifiers',
    skip_this_step: 'Skip this step',
    modifier_name: 'Modifier name',
    print_in_receipt: 'Print in receipt',
    apply_modifier_on_these_items: 'Apply modifier on these items',
    add_items_to_modifier: 'Add items to modifier',
    add_items: 'Add items',
    modifier: 'Modifier',
    price: 'Price',
    stock_status: 'Stock status',
    rs_zero: 'Rs.0',
    saved_orders: 'Saved orders',
    when_a_new_order_is_created_the_ongoing_order_will_be_saved_here: 'When a new order is created, the ongoing order will be saved here.',
    easypaisa: 'Easypaisa',
    jazzcash: 'Jazzcash',
    enter_Jazzcash_account_number: 'Enter Jazzcash account number',
    enter_easypaisa_account_number: 'Enter Easypaisa account number',
    enter_number: 'Enter number',
    verifying_account: 'Verifying account',
    account_fetched_successfully: 'Account fetched successfully',
    account_title: 'Account title',
    account_number: 'Account number',
    sorry_account_not_found_Try_again: 'Sorry account not found. Try again',
    bank: 'Bank',
    verified_account_by: 'Verified account by',
    oTP_code_has_been_sent_to: 'OTP code has been sent to',
    sms_code_ka_wait_time: 'SMS code ka wait time',
    code_nahi_mila: 'Code nahi mila? ',
    sms: 'SMS',
    call: 'Call',
    customer_se_kahein_woh_apni_Jazzcash_app_se_MPIN_verify_kare: 'Customer se kahein woh apni Jazzcash app se MPIN verify kare',
    waiting_for_MPIN_confirmation: 'Waiting for MPIN confirmation',
    request_MPIN: 'Request MPIN',
    customer_added: 'Customer added',
    create_customer_and_add_them_into_sales: 'Create customer and add them into sales',
    full_name: 'Full name',
    phone: 'Phone',
    country: 'Country',
    select_country: 'Select Country',
    drafts_saved: 'Drafts saved',
    customer_created_successfully: 'Customer created successfully',
    search_by_name: 'Search by name',
    order_no: 'Order no',
    points_earned: 'Points earned',
    payment: 'Payment',
    summary_and_details: 'Summary & details',
    loyalty_point_available: 'Loyalty point available',
    payment_received_by_cash_of: 'Payment received by cash of',
    paid_by_customer: 'Paid by customer',
    order_history_not_found_start_selling: 'order history not found, start selling',
    start_selling: 'Start selling',
    never: 'Never',
    do_you_really_want_to_archive_this_customer: 'Do you really want to archive this customer?',
    do_you_really_want_to_unarchive_this_customer: 'Do you really want to unarchive this customer?',
    customer_archive_successfully: 'Customer archive successfully',
    customer_unarchive_successfully: 'Customer unarchive successfully',
    no_archive_customers_found: 'No archive customers found',
    no_draft_customers_found: 'No draft customers found',
    archive_customers: 'Archive customers',
    no_customers_found: 'No customers found',
    change_file: 'Change file',
    library_imported_successfully: 'Library imported successfully',
    place_order: 'Place order',
    update_order: 'Update order',
    item: 'Item',
    draft_customer: 'Draft Customer',
    total_visits: 'Total visits',
    pay_credits: 'Pay credits',
    credit_history: 'Credit history',
    search_by_amount: 'Search by amount',
    pay_date: 'Pay date',
    credit_history_not_found: 'Credit history not found',
    floor_plan: 'Floor plan',
    guests: 'Guests',
    dob: 'DOB',
    customer_updated_successfully: 'Customer updated successfully',
    csv_uploaded: 'CSV uploaded',
    action: 'Action',
    remove_waiter: 'Waiter removed successfully',
    add_waiter: 'Waiter added successfully',
    update_waiter: 'Waiter updated successfully',
    write_note: 'Write note...',
    note_placeholder: 'E.g Cut burger in half',
    clear_note: 'Clear note',
    add_note: 'Add note',
    void_item: 'Void item',
    add_void_reason: 'Add void reason',
    void_notes: 'Void notes',
    void_placeholder: 'Customer changed mind',
    how_many_loyalty_points_would_you_like_to_redeem: 'How many loyalty points would you like to redeem?',
    date_and_time: 'Date & time',
    customer_id: 'Customer ID',
    transaction_id: 'Transaction ID',
    succeeded: 'Succeeded',
    master: 'Master',
    visa: 'Visa',
    search_by_customer_name_phone_and_transactin_id: 'Customer name, phone, transaction ID',
    search_by_name_and_transactin_id: 'Search by name and transaction ID',
    export_pdf: 'Export PDF',
    item_library: 'Item library',
    money_in: 'Money in',
    money_out: 'Money out',
    method: 'Method',
    wallet_summary: 'Wallet summary',
    wallet_balance: 'Wallet balance',
    payout: 'Payout',
    refunded: 'Refunded',
    titles: 'Titles',
    split_bill_by_amount: 'Split bill by amount',
    dividing_the_cost: 'Dividing the total cost of a bill or expense among multiple people based on specific amounts each person owes.',
    customer_published_successfully: 'Customer published successfully',
    customer_saved_into_draft: 'Customer saved into draft',
    all_types: 'All types',
    void_orders: 'Void orders',
    paid_orders: 'Paid orders',
    cash_payment: 'Cash payment',
    card_payment: 'Card payment',
    wallet_payment: 'Wallet payment',
    credit_payment: 'Credit payment',
    complete_order: 'Complete order',
    order_no: 'Order no.',
    search_by_order_number: 'Search by order number',
    maximum_discount_cap: 'Maximum discount cap',
    discounts_name: 'Discount name',
    amount_type: 'Amount type',
    discount_created_successfully: 'Discount created successfully',
    discount_updated_successfully: 'Discount updated successfully',
    discount_published_successfully: 'Discount published successfully',
    discount_saved_into_draft: 'Discount saved into draft',
    draft_discount: 'Draft discount',
    no_archive_discounts_found: 'no archive discounts found',
    no_draft_discounts_found: 'no draft discounts found',
    tax_is_to_be_added_on_top_of_price: 'Tax is to be added on top of price',
    tax_is_already_included_in_Price: 'Tax is already included in Price',
    tax_behavior: 'Tax behavior',
    no_archive_tax_found: 'no archive tax found',
    no_purchase_found: 'no Purchase tax found',
    no_Sales_tax_found: 'no Sales tax found',
    purchase_tax_created_successfully: 'Purchase tax created successfully',
    purchase_tax_updated_successfully: 'Purchase tax updated successfully',
    sale_tax_created_successfully: 'Sales tax created successfully',
    sale_tax_updated_successfully: 'Sales tax updated successfully',
    create_items_and_start_selling: 'Create items and start selling',
    edit_item: 'Edit item',
    item_created_successfully: 'Item created successfully',
    item_updated_successfully: 'Item updated successfully',
    member_credential_details: 'Member credential details',
    create_and_manage_your_team: 'Create and manage your team',
    team_member: 'Team member',
    create_purchase_order_and_manage_inventory: 'Create purchase order and manage inventory',
    purchase_order_details: 'Purchase order details',
    item_information: 'Item information',
    ingredient: 'Ingredient',
    u_cost: 'U. Cost (Rs)',
    amount_with_rs: 'Amount (Rs)',
    global_discount: 'Global discount',
    team_member_created_successfully: 'Team member created successfully',
    team_member_updated_successfully: 'Team member updated successfully',
    po_created_successfully: 'po created successfully',
    po_saved_into_draft: 'po saved into draft',
    po_rejected: 'purchase order rejected',
    po_pending: 'purchase order pending',
    po_approved: 'purchase order approved',
    order_note: 'Order note',
    note_added: 'Note added',
    enabled: 'Enabled',
    disabled: 'Disabled',
    app_settings: 'App settings',
    import_discount: 'Import discount',
    set_up_items: 'Set up Items',
    go_to_pos: 'Go to POS',
    before_you_open_your_business_first_you_need_some_items: 'Before you open your business, first you need some items.',
    create_categories_and_add_them_into_items: 'Create categories and add them into items',
    edit_tile_color: 'Edit tile color',
    variation_details: 'Variation details',
    variation_display_name: 'Variation display name',
    create_variation: 'Create variation',
    search_category_by_name: 'Search category by name...',
    create_categories: 'Create categories',
    item_name: 'Item name',
    selling_price: 'Selling price',
    add_quantity: 'Add quantity',
    primary_unit: 'Primary unit',
    add_variations: 'Add variations',
    drag_image: 'Drag image',
    upload_file_or_drag_here: 'Upload file or drag here',
    upload_only_jpeg_jpg_or_png: 'Upload only jpeg, jpg or png',
    profit_will_be_automatically_calculated_and_displayed_when_adding_selling_price_and_item_cost:
        'Profit will be automatically calculated and displayed when adding selling price and item cost.',
    margin_will_be_automatically_calculated_and_displayed_when_adding_selling_price_and_item_cost:
        'Margin will be automatically calculated and displayed when adding selling price and item cost.',
    item_published_successfully: 'Item published successfully',
    item_saved_into_draft: 'Item saved into draft',
    do_you_really_want_to_discard_this_item: 'Do you really want to discard this item?',
    this_action_is_irreversible_once_you_discard_your_item_it_gone: "This action is irreversible, once you discard your item, it's gone.",
    stock: 'Stock',
    loading: 'loading',
    max_5MB: 'Max. 5MB',
    no_archive_items_found: 'No archive items found',
    no_draft_items_found: 'No draft items found',
    no_low_stock_items_found: 'No low stock items found',
    no_sold_out_items_found: 'No sold out items found',
    all_items: 'All items',
    please_enter_all_required_fileds: 'Please enter all required fileds',
    item_is_on_low_stock_please_add_more_items: 'Item is on low stock, please add more items.',
    item_sold_out_please_add_more_items: 'Item sold out, please add more items.',
    we_couldnt_find_any_results_for_your_search: "We couldn't find any results for your search.",
    please_go_to_the_POS_and_add_items_to_the_list: 'Please go to the POS and add items to the list.',
    search: 'Search...',
    all_categories: 'All categories',
    category_created_successfully: 'Category created successfully',
    category_updated_successfully: 'Category updated successfully',
    edit_category: 'Edit category',
    create_category: 'Create category',
    do_you_really_want_to_discard: 'Do you really want to discard?',
    this_action_is_irreversible_once_you_discard_it_its_gone: "This action is irreversible, once you discard it, it's gone.",
    do_you_really_want_to_archive_this_category: 'Do you really want to archive this category?',
    do_you_really_want_to_unarchive_this_category: 'Do you really want to unarchive this category?',
    category_archive_successfully: 'Category archive successfully',
    category_unarchive_successfully: 'Category unarchive successfully',
    company_name: 'company name',
    zip_code: 'Zip code',
    all_company: 'All Company',
    create_new_company_and_add_to_sale: 'Create new company and add to sale',
    no_draft_companies_found: 'No draft companies found',
    draft_company: 'Draft company',
    company_created_successfully: 'Company created successfully',
    company_updated_successfully: 'Company updated successfully',
    company_published_successfully: 'Company published successfully',
    company_saved_into_draft: 'Company saved into draft',
    loading_with_dot: 'loading...',
    location_name: 'Location name',
    location_type: 'Location type',
    salary_type: 'Salary type',
    salary_amount: 'Salary amount',
    do_you_want_to_proceed_this_order: 'Do you want to proceed refund for this order?',
    select_items_for_refund: 'Select items for refund',
    primary_and_Secondary_Units: 'Primary and secondary units',
};
